import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
    GET_SELLER_PAYMENT_DETAILS: '/api/seller/payment/seller_payment_details/',
    SEND_WITHDRAWAL_REQUEST: '/api/seller/payment/send_withdrawal_request',
    GET_PAYMENT_REQUEST : '/api/admin/payment/get_seller_payment_request',
    CONFIRM_PAYMENT_REQUEST: '/api/admin/payment/request-confirm'
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

export const get_seller_payment_details = createAsyncThunk(
    "payment/get_seller_payment_details",
    async (sellerId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(API_ROUTES.GET_SELLER_PAYMENT_DETAILS+`${sellerId}`, { withCredentials: true });
            //console.log("Info utilisateur friend :", data);
            return fulfillWithValue(data);

        } catch (error) {
           // console.error("Erreur lors de d'ajout d'un ami : ", error);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const send_withdrawal_request = createAsyncThunk(
    "payment/send_withdrawal_request",
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(API_ROUTES.SEND_WITHDRAWAL_REQUEST,info, { withCredentials: true });
            //console.log("Info utilisateur friend :", data);
            return fulfillWithValue(data);
        } catch (error) {
           // console.error("Erreur lors de d'ajout d'un ami : ", error);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const get_withdrawal_request = createAsyncThunk(
    'payment/get_withdrawal_request',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        const token = getState().auth.token
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            const { data } = await api.get(API_ROUTES.GET_PAYMENT_REQUEST, config)
           // console.log('data for get_withdrawal_request', data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const confirm_payment_request = createAsyncThunk(
    'payment/confirm_payment_request',
    async (paymentId, { rejectWithValue, fulfillWithValue, getState }) => {
        const token = getState().auth.token
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            const { data } = await api.post(API_ROUTES.CONFIRM_PAYMENT_REQUEST, { paymentId }, config)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


// Reducer principal
export const paymentReducer = createSlice({
    name: "payment",
    initialState: {
        successMessage: "",
        messageError: "",
        loader : false,
        pendingWithdraws : [],
        successWithdraws : [],
        totalAmount : 0,
        withdrawalAmount : 0,
        pendingAmount : 0,
        availableAmount : 0
    },
    reducers: {
        setChatInfo: (state, action) => {
            state.chatInfo = action.payload;
        },
        messageClear: (state) => {
            state.messageError = "";
            state.successMessage = "";
        },
       
    },
   
    extraReducers: (builder) => {
        builder 
            .addCase(get_seller_payment_details.pending, (state) => {
                state.loader = true;
                state.messageError = "";
            })
            .addCase(get_seller_payment_details.rejected, (state, action) => {
                state.loader = false;
                state.messageError = action.payload;
            })
            .addCase(get_seller_payment_details.fulfilled, (state, action) => {
                state.loader = false ;
                state.messageError = "";
                state.successMessage = action.payload.message;
                state.pendingWithdraws = action.payload.pendingWithdraws;
                state.successWithdraws = action.payload.successWithdraws;
                state.totalAmount = action.payload.totalAmount;
                state.withdrawalAmount = action.payload.withdrawalAmount;
                state.pendingAmount = action.payload.pendingAmount;
                state.availableAmount = action.payload.availableAmount;
            })
            .addCase(send_withdrawal_request.pending, (state) => {
                state.loader = true;
                state.messageError = "";
            })
            .addCase(send_withdrawal_request.rejected, (state, action) => {
                state.loader = false;
                state.messageError = action.payload;
            })
            .addCase(send_withdrawal_request.fulfilled, (state, action) => {
                state.loader = false ;
                state.messageError = "";
                state.successMessage = action.payload.message;
                state.pendingWithdraws  = [action.payload.withdrawal, ...state.pendingWithdraws];
                state.availableAmount = state.availableAmount-action.payload.withdrawal.amount;
                state.pendingAmount = action.payload.withdrawal.amount;

            })
            .addCase(get_withdrawal_request.pending, (state) => {
                state.loader = true;
                state.messageError = "";
            })
            .addCase(get_withdrawal_request.rejected, (state, action) => {
                state.loader = false;
                state.messageError = action.payload;
            })
            .addCase(get_withdrawal_request.fulfilled, (state, action) => {
                state.loader = false ;
                state.messageError = "";
                state.successMessage = action.payload.message;
                state.pendingWithdraws = action.payload.withdrawalRequest;
            })
            .addCase(confirm_payment_request.pending, (state) => {
                state.loader = true;
                state.messageError = "";
            })
            .addCase(confirm_payment_request.rejected, (state, action) => {
                state.loader = false;
                state.messageError = action.payload;
            })
            .addCase(confirm_payment_request.fulfilled, (state, action) => {
                state.loader = false ;
                state.messageError = "";
                state.successMessage = action.payload.message;
                state.pendingWithdraws = state.pendingWithdraws.filter((item) => item.id !== action.payload.withdrawal.id);
            })
                      
    },
   
});

export const { setChatInfo, messageClear} = paymentReducer.actions;
export default paymentReducer.reducer;
